import { render, staticRenderFns } from "./TabsExperiences.vue?vue&type=template&id=5fc90ae6&"
import script from "./TabsExperiences.vue?vue&type=script&lang=js&"
export * from "./TabsExperiences.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports